import { z } from 'zod';
import { oneOf } from '../../navigation/searchParams';

/**
 * `required` is set by the role guard, which knows the exact tier; `forbidden`
 * by the permission guards and the 403 interceptor, which don't. Either
 * selects the access-denied variant.
 */
export const unauthorizedSearch = z.object({
  required: oneOf(['viewer', 'operator', 'admin']),
  forbidden: oneOf(['1']),
});
